<script lang="ts">
	import Router from "svelte-spa-router";
	import { wrap } from "svelte-spa-router/wrap";

	import "carbon-components-svelte/css/all.css";
	import {
		Column,
		Content,
		Grid,
		Header,
		HeaderGlobalAction,
		HeaderNav,
		HeaderNavItem,
		HeaderUtilities,
		Link,
		Row,
		SkipToContent,
	} from "carbon-components-svelte";
	import LogoTwitter24 from "carbon-icons-svelte/lib/LogoTwitter24";

	import DirectInput from "./DirectInput.svelte";
	import TypeWriter from "./TypeWriter.svelte";

	export let core;

	let isSideNavOpen = false;
	let activeComponent;
	let isDirectInputSelected: boolean = false;
	$: isDirectInputSelected = activeComponent === "DirectInput";

	let isTypewriterSelected: boolean = false;
	$: isTypewriterSelected = activeComponent === "TypeWriter";

	const routes = {
		"/typewriter": wrap({
			component: TypeWriter,
			props: {
				core: core,
			},
		}),
		"*": wrap({
			component: DirectInput,
			props: {
				core: core,
			},
		}),
	};

	function routeEvent(event) {
		activeComponent = event?.detail?.component;
	}

	function shareWithTwitter() {
		window.open(
			"https://twitter.com/intent/tweet?text=Generated%20a%20text%20full%20of%20Slack%20Emoji%20alphabets%20with%20https://slacktype.bitbears.dev",
			"_blank"
		);
	}
</script>

<div class="container">
	<Header
		company="bitbears.dev"
		platformName="Slacktype"
		bind:isSideNavOpen
		href="https://bitbears.dev"
	>
		<div slot="skip-to-content">
			<SkipToContent />
		</div>
		<HeaderNav>
			<HeaderNavItem
				text="Direct Input"
				href="/"
				bind:isSelected={isDirectInputSelected}
			/>
			<HeaderNavItem
				text="Typewriter"
				href="/#/typewriter"
				bind:isSelected={isTypewriterSelected}
			/>
		</HeaderNav>
		<HeaderUtilities>
			<HeaderGlobalAction
				aria-label="Share with Twitter"
				icon={LogoTwitter24}
				on:click={shareWithTwitter}
			/>
		</HeaderUtilities>
	</Header>

	<Content>
		<Router {routes} on:routeEvent={routeEvent} />
	</Content>

	<footer class="bx--content">
		<Grid>
			<Row>
				<Column>
					<p class="creator">
						Created by: <Link
							href="https://twitter.com/0xb17bea125"
							target="_blank">t@bitbears.dev</Link
						>
					</p>
					<p>&copy; 2021 bitbears.dev</p>
				</Column>
			</Row>
		</Grid>
	</footer>
</div>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
	footer {
		margin-top: auto !important;
		background: var(--cds-ui-01);

		p.creator {
			font-weight: bolder !important;
		}
	}
</style>
